import { Component } from '@angular/core';
import { detectBody } from './app.helpers';
import { ToasterConfig, ToasterService } from 'angular2-toaster/angular2-toaster';
import { ErrorHandler } from './services/ErrorHandler';
import {Router} from '@angular/router';
import {LastUrl} from './services/LastRouteService';
import {FloatingButtonGlobalInfo_hidden} from './modules/floating-button/xservice';

declare var jQuery:any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    public toasterconfig : ToasterConfig = new ToasterConfig({
            showCloseButton: true,
            iconClasses: {'success':'none', 'info': 'none'},
            timeout: 4000
        });

    constructor(
        private toasterService: ToasterService,
        private router: Router,
        private _hidden_xservice: FloatingButtonGlobalInfo_hidden
    ) {
        const errorHandler = ErrorHandler.getInstance();
        //todo change this
        // errorHandler.ee.subscribe((item) => {
        //     const body = JSON.parse(item._body);
        //     const errorTitle = body.message;
        //     const errorBody = body.errors.map((item) => item.message).join('\n');
        //     this.toasterService.pop('error', errorTitle, errorBody);
        // })
        this.router.events
            .subscribe(e => {
                LastUrl.setNew(e.url);
            });
    }

    ngAfterViewInit() {
        // Run correctHeight function on load and resize window event
        jQuery(window).bind("load resize", function() {
            detectBody();
        });

        setInterval(() => {
            jQuery('[data-toggle="tooltip"]').tooltip()
        }, 300);
    }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts